import { each, uniq, sortBy } from 'lodash-es'
import snmpOid from '@/configuration/snmpOid'

/**
 * @function parseOid
 * @desc Parse SNMP log to dislay OID names / codes.
 * @param {object}  snmpLogContent  - SNMP log.
 * @return {object} Javascript object without deleted attributes.
 */
const parseOid = snmpLogContent => {
  if (!snmpLogContent) return ''

  let parsedContent = snmpLogContent
  let foundOids = []

  // WARNING
  // According to order in snmpOid.js, long oids can be replace by small oids with the same beginning
  // We can't sort snmpOid as it is an object (objects are not sortables)
  // So to prevent that, we save found oids in an array, sort them by length and then do the replacement

  // Look for oids in snmp logs content
  each(snmpOid, (name, value) => {
    if (parsedContent.indexOf(value) !== -1) {
      const oid = {
        value: value,
        name: name
      }
      foundOids.push(oid)
    }
  })

  // Sort found oids
  foundOids = uniq(foundOids)
  foundOids = sortBy(foundOids, [(oid) => {
    return -oid.value.length
  }])

  // Do the replacement
  each(foundOids, oid => {
    parsedContent = parsedContent.replace(new RegExp(oid.value, 'g'), oid.name)
  })

  return parsedContent
}

export default parseOid
